import {Injectable} from '@angular/core';
import {Language} from '@services/language';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public readonly languages: Language[] = [new Language('Deutsch', 'de'), new Language('English', 'en'), new Language('Français', 'fr')];

  constructor(public translate: TranslateService) {}

  public initBrowserLanguage() {
    this.translate.addLangs(this.langAsISO6391());
    const browserLang = this.translate.getBrowserLang()!;
    if (this.langAsISO6391().includes(browserLang) || !(browserLang !== undefined)) {
      this.translate.use(browserLang);
    } else {
      this.translate.use('en');
    }
  }

  private langAsISO6391() {
    return this.languages.map((l: Language) => l.iso6391);
  }
}
